import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { MotifAvatar } from '../../avatar/avatar';
import { DefaultOptionTemplate } from './default-template';

/**
 * @typedef Props
 * @prop {{name: string, image: string, status: string, disabled: boolean }} [item]
 * @prop {string} [searchTerm]
 * @prop {string} [value]
 */
/**
 * @param {Props} props
 */
const MotifPeopleTemplate = ({ item: { name, image, status, disabled } = {}, searchTerm = '', value = '' }) => {
  const classes = classNames({
    'motif-people-template': true,
    'motif-people-template-disabled': disabled
  });

  return (
    <div className={classes} data-motif-people-template>
      <MotifAvatar userName={name} src={image} aria-hidden={true} />
      <span className="motif-people-details">
        {searchTerm ? <DefaultOptionTemplate searchTerm={searchTerm} value={value} /> : name}
        <span className="motif-people-status">{status}</span>
      </span>
    </div>
  );
};

MotifPeopleTemplate.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.string,
    image: PropTypes.string,
    status: PropTypes.string,
    disabled: PropTypes.bool
  }),
  value: PropTypes.string,
  searchTerm: PropTypes.string
};

export { MotifPeopleTemplate };
